export default function SideActions() {
  return (
    <div
      className="fixed right-0 top-1/2 z-40 flex -translate-y-1/2 flex-col gap-[3px]"
      aria-label="募集導線"
    >
      <a
        href="#sponsor"
        className="group flex h-[152px] w-[46px] cursor-pointer flex-col items-center justify-center gap-2 rounded-l-md border border-r-0 border-white/25 text-white transition-transform duration-500 hover:-translate-x-1 md:h-[184px] md:w-[62px] md:gap-3"
        style={{ backgroundColor: '#e2001a' }}
        aria-label="企業協賛募集中"
      >
        <i className="ri-mail-send-line text-[17px] transition-transform duration-500 group-hover:scale-110 md:text-[20px]" aria-hidden="true" />
        <span className="vertical-jp text-[12px] font-bold leading-none md:text-[14px]">協賛募集中</span>
      </a>

      <a
        href="#vendor"
        className="group flex h-[152px] w-[46px] cursor-pointer flex-col items-center justify-center gap-2 rounded-l-md border border-r-0 border-white/25 text-white transition-transform duration-500 hover:-translate-x-1 md:h-[184px] md:w-[62px] md:gap-3"
        style={{ backgroundColor: '#009944' }}
        aria-label="出店者募集中"
      >
        <i className="ri-store-2-line text-[17px] transition-transform duration-500 group-hover:scale-110 md:text-[20px]" aria-hidden="true" />
        <span className="vertical-jp text-[12px] font-bold leading-none md:text-[14px]">出店者募集中</span>
      </a>
    </div>
  );
}